import React, { Fragment, Suspense } from "react";
import { ToastContainer } from "react-toastify";
import AppRoutes from "../../routes/AppRoutes";

const AppMain = () => {
  return (
    <Fragment>
      <Suspense fallback={<div className="loader-container" />}>
        <AppRoutes />
      </Suspense>

      <ToastContainer />

    </Fragment>
  );
};

export default AppMain;
